import {
  Button,
  Card,
  editorConfigOptions,
  ErrorMessage,
  Header,
  Input,
  JoditEditor,
  success,
  SwitchInput,
  useCustomForm,
  useRef,
} from "@";
import { savePage } from "./utils/api";
import { defaultValues, schema } from "./utils/validation";

const Create = () => {
  // stats and variables
  const editor = useRef(null);
  const links = [
    { name: "الصفحات", link: "/website/pages" },
    { name: "اضافة", link: "" },
  ];

  // form handling and validation using the useCustomForm hook
  const {
    reset,
    watch,
    errors,
    setValue,
    register,
    handleSubmit,
    isSubmitting,
  } = useCustomForm(defaultValues, schema);

  // submit function to handle form submission
  const submit = async (data) => {
    try {
      await savePage(data);
      success("تم الاضافة بنجاح");
      reset();
    } catch (error) {}
  };

  return (
    <>
      {/* header */}
      <Header title="اضافة صفحة " links={links} />

      <form onSubmit={handleSubmit(submit)}>
        <Card>
          <div className="grid gap-5 p-5 lg:grid-cols-3">
            <Input
              label="عنوان الصفحة"
              error={errors.pageTitle}
              input={register("pageTitle")}
            />

            <Input
              star
              label="رابط خارجى"
              error={errors.externalPageUrl}
              input={register("externalPageUrl")}
            />

            <Input
              star
              label="ترتيب الصفحة"
              error={errors.order}
              input={register("order")}
            />

            <SwitchInput
              label="نشط"
              checked={watch("isActive")}
              change={(value) => setValue("isActive", value)}
            />

            <SwitchInput
              label="اظهار في القائمة العلوية"
              checked={watch("showHeaderMenu")}
              change={(value) => setValue("showHeaderMenu", value)}
            />

            <SwitchInput
              label="اظهار القائمة السفلية"
              checked={watch("showLowerMenu")}
              change={(value) => setValue("showLowerMenu", value)}
            />
          </div>
        </Card>

        <Card title="محتوى الصفحة">
          <JoditEditor
            ref={editor}
            tabIndex={1}
            config={editorConfigOptions}
            value={watch("summary")}
            onChange={(newContent) => setValue("summary", newContent)}
          />
          <ErrorMessage value={errors.summary?.message} />
        </Card>

        <Button isLoading={isSubmitting} type="submit" title="حفظ البيانات" />
      </form>
    </>
  );
};

export default Create;
